// @flow
import api from 'tim-api';
import { visits as visitsEndPoint, places as placesEndPoint } from 'endPoints';
import { serialize } from 'utils';

type Filter = {
  date: string
}

export const state: Object = {
  visits: [],
  places: [],
  pagination: {}
};

export const getters = {
  visits: (state: Object) => state.visits || [],
  places: (state: Object) => state.places || [],
  getVisitId: (state: Object) => (id: Number) => id
    && state.visits.find(visit => visit.visit_id === id),
  pagination: (state: Object) => state.pagination
};

export const mutations = {
  SET_PLACES(state: Object, places: Array<Object>) {
    state.places = places;
  },

  SET_PLACE(state: Object, payload: Object) {
    state.place = {
      ...state.place,
      ...payload
    };
  },
  SET_VISITS(state: Object, visits: Array<Object>) {
    state.visits = visits;
  },
  SET_PAGINATION(state: Object, pagination: Object) {
    state.pagination = pagination;
  },
  SET_VISIT(state: Object, payload: Object) {
    state.visit = {
      ...state.visit,
      ...payload
    };
  }
};

export const actions = {
  fetchVisits({ commit }: Action, filter: Filter) {
    const serializedFilter: string = serialize(filter);

    return api.get(`${visitsEndPoint}?paginate=true&${serializedFilter}`).then(({ data }) => {
      commit('SET_VISITS', data.data);
      commit('SET_PAGINATION', {
        current_page: data.current_page,
        first_page_url: data.first_page_url,
        from: data.from,
        last_page: data.last_page,
        last_page_url: data.last_page_url,
        next_page_url: data.next_page_url,
        path: data.path,
        per_page: data.per_page,
        prev_page_url: data.prev_page_url,
        total: data.total
      });
    });
  },

  // eslint-disable-next-line
  sendVisit({ commit }: Action, visit: Object) {
    return api.post(visitsEndPoint, visit);
  },
  setVisit({ commit }: Action, payload: Object) {
    commit('SET_VISIT', payload);
  },

  // eslint-disable-next-line
  sendPlace({ commit }: Action, place: Object) {
    return api.post(placesEndPoint, place);
  },
  setPlace({ commit }: Action, payload: Object) {
    commit('SET_PLACE', payload);
  },

  fetchVisitsByPage({ commit }: Action, pageIndex: number) {
    commit('SET_VISITS', []);
    return api.get(`${visitsEndPoint}?page=${pageIndex}&paginate=true`).then(({ data }) => {
      commit('SET_VISITS', data.data);
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
